import Logo from "../assets/logo.png";
import Repsol from "../assets/logos/repsol.jpg";
import Cepsa from "../assets/logos/cepsa.png";
import Galp from "../assets/logos/galp.png";
import Shell from "../assets/logos/shell.png";
import BP from "../assets/logos/bp.png";
import Petronor from "../assets/logos/petronor.png";
import Avia from "../assets/logos/avia.png";
import Petroprix from "../assets/logos/petroprix.png";
import Plenoil from "../assets/logos/plenoil.jpg";
import Campsa from "../assets/logos/campsa.png";
import Valcarce from "../assets/logos/valcarce.jpg";

export const getStationLogo = (name) => {
  name = name || "";
  if (name.toLowerCase().includes("repsol")) return Repsol;
  if (name.toLowerCase().includes("cepsa")) return Cepsa;
  if (name.toLowerCase().includes("galp")) return Galp;
  if (name.toLowerCase().includes("shell")) return Shell;
  if (name.toLowerCase().includes("bp")) return BP;
  if (name.toLowerCase().includes("petronor")) return Petronor;
  if (name.toLowerCase().includes("avia")) return Avia;
  if (name.toLowerCase().includes("petroprix")) return Petroprix;
  if (name.toLowerCase().includes("plenoil")) return Plenoil;
  if (name.toLowerCase().includes("campsa")) return Campsa;
  if (name.toLowerCase().includes("valcarce")) return Valcarce;

  return Logo;
};
